import { render, staticRenderFns } from "./BusinessSummarySupply.vue?vue&type=template&id=84a242cc&scoped=true"
import script from "./BusinessSummarySupply.vue?vue&type=script&lang=js"
export * from "./BusinessSummarySupply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a242cc",
  null
  
)

export default component.exports